(() => {
  if (window.__ambecaLetterSelectorInitialized) return;
  window.__ambecaLetterSelectorInitialized = true;

  const finishMediaLabel = (value) => {
    if (/silver/i.test(value)) return 'Silver Tone';
    return '18K Gold Plated';
  };

  const sync = () => {
    const mapNode = document.querySelector('[data-ambeca-letter-media-map]');
    const picker = document.querySelector('variant-picker');
    const gallery = document.querySelector('media-gallery');
    if (!mapNode || !picker || !gallery) return;

    let data;
    try {
      data = JSON.parse(mapNode.textContent);
    } catch (_) {
      return;
    }

    document.body.classList.add('ambeca-letter-product');
    picker.querySelectorAll('[data-option-name="Finish"] .m-product-option__input').forEach((input) => {
      const label = picker.querySelector(`label[for="${CSS.escape(input.id)}"]`);
      if (!label) return;
      label.classList.add(
        /silver/i.test(input.value)
          ? 'ambeca-letter-finish--silver'
          : 'ambeca-letter-finish--gold',
      );
      label.setAttribute('aria-label', input.value);
      label.setAttribute('title', input.value);
    });

    const finish = picker.querySelector(
      '[data-option-name="Finish"] .m-product-option__input:checked',
    )?.value;
    const letter = picker.querySelector(
      '[data-option-name="Letter"] .m-product-option__input:checked',
    )?.value;
    if (!finish || !letter) return;

    const finishLabel = finishMediaLabel(finish);
    const activeIds = data.media
      .filter(
        (item) =>
          item.alt?.includes(`Letter ${letter},`) && item.alt?.includes(`, ${finishLabel},`),
      )
      .map((item) => String(item.id));
    if (!activeIds.length) return;

    gallery.querySelectorAll('[data-media-id]').forEach((item) => {
      const activeIndex = activeIds.indexOf(String(item.dataset.mediaId));
      const active = activeIndex >= 0;
      item.toggleAttribute('data-ambeca-letter-active', active);
      item.toggleAttribute('data-ambeca-letter-hidden', !active);
      item.toggleAttribute('data-ambeca-letter-primary', activeIndex === 0);
      item.setAttribute('aria-hidden', active ? 'false' : 'true');
    });
  };

  let timer;
  const scheduleSync = () => {
    clearTimeout(timer);
    sync();
    timer = setTimeout(sync, 80);
    setTimeout(sync, 260);
    setTimeout(sync, 700);
  };

  document.addEventListener(
    'change',
    (event) => {
      if (event.target.closest?.('variant-picker')) scheduleSync();
    },
    true,
  );
  document.addEventListener('shopify:section:load', scheduleSync);
  window.addEventListener('popstate', scheduleSync);

  const observer = new MutationObserver((mutations) => {
    if (
      mutations.some((mutation) =>
        [...mutation.addedNodes].some(
          (node) =>
            node.nodeType === 1 &&
            (node.matches?.('variant-picker, media-gallery') ||
              node.querySelector?.('variant-picker, media-gallery')),
        ),
      )
    ) {
      scheduleSync();
    }
  });

  const start = () => {
    scheduleSync();
    observer.observe(document.body, { childList: true, subtree: true });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
